module.exports = __webpack_public_path__ + "img/history_icon.da0818be.svg";